/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CandidateOffersIdApplyQuestions,
    CandidateOffersIdApplyQuestionsFromJSON,
    CandidateOffersIdApplyQuestionsFromJSONTyped,
    CandidateOffersIdApplyQuestionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
    /**
     * 
     * @type {number}
     * @memberof InlineObject1
     */
    letter?: number;
    /**
     * 
     * @type {Array<CandidateOffersIdApplyQuestions>}
     * @memberof InlineObject1
     */
    questions?: Array<CandidateOffersIdApplyQuestions>;
}

export function InlineObject1FromJSON(json: any): InlineObject1 {
    return InlineObject1FromJSONTyped(json, false);
}

export function InlineObject1FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineObject1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'letter': !exists(json, 'letter') ? undefined : json['letter'],
        'questions': !exists(json, 'questions') ? undefined : ((json['questions'] as Array<any>).map(CandidateOffersIdApplyQuestionsFromJSON)),
    };
}

export function InlineObject1ToJSON(value?: InlineObject1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'letter': value.letter,
        'questions': value.questions === undefined ? undefined : ((value.questions as Array<any>).map(CandidateOffersIdApplyQuestionsToJSON)),
    };
}


